import { jsxs as _jsxs } from "react/jsx-runtime";
import { STATES } from "../../form/states-field";
import { prop } from "../template";
const DEFAULT_VALUE = {
    label: "",
};
export const StateNameRenderer = ({ values, stateId }) => {
    const selectedStateId = prop(values, stateId, stateId);
    const state = STATES.find(state => state.id === selectedStateId);
    return _jsxs("span", { children: [" ", (state || DEFAULT_VALUE).label] });
};
